export const fakeFunction = x => x;

export const clearResolve = resolve => (resolve = fakeFunction);

export const awaiResolve = resolve => new Promise(r => (resolve = r));

export const bindPromise = (fx, resolve) => (...args) => {
  fx(...args);
  resolve();
  clearResolve(resolve);
};
